import React from 'react';

const HTMLString = ({ htmlString }) => {
  const formatted = htmlString?.replace(/\n/g, "<br/>");

  return (
    <div dangerouslySetInnerHTML={{ __html: formatted }} />
  );
}

export default HTMLString;